import React, {
  forwardRef, useEffect, useMemo, useState,
} from 'react';
import { TransitionProps } from '@mui/material/transitions';
import {
  Dialog, DialogContent, DialogTitle, IconButton, Zoom,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadTwoToneIcon from '@mui/icons-material/CloudDownloadTwoTone';
import { useDispatch } from 'react-redux';
import { TypesScannedImageDialog } from '../utils/types';
import { setLoader } from '../../../redux/loaderSlice';

const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
  // eslint-disable-next-line react/jsx-props-no-spreading
) => <Zoom ref={ref} {...props} />);

function DialogScannedImage({
  show, setOpenImage, filePath, fileName,
}: TypesScannedImageDialog): JSX.Element {
  // Function to handle image download
  const [imgUrl, setImgUrl] = useState<string>('');
  const dispatch = useDispatch();

  const handleImageAction = () => {
    setOpenImage(false);
    // setTimeout(() => {
    setImgUrl('');
    // }, 700);
  };

  const isPdf = useMemo(() => fileName?.toLowerCase().endsWith('.pdf'), [fileName]);
  useEffect(() => {
    if (show && filePath && fileName) {
      dispatch(setLoader(true));
      if (filePath.startsWith('https://')) {
        setImgUrl(filePath);
      } else {
        const base64String = filePath;
        if (isPdf) {
          setImgUrl(`data:application/pdf;base64,${base64String}`);
        } else {
          setImgUrl(`data:image/jpeg;base64,${base64String}`);
        }
      }
    }
  }, [filePath, show, isPdf]);

  const handleImageLoad = () => {
    dispatch(setLoader(false));
  };

  function toDataURL(url: string) {
    return fetch(`${url}?_=${new Date().getTime()}`)
      .then((response) => response.blob())
      .then((blob) => URL.createObjectURL(blob));
  }

  async function downloadImage() {
    dispatch(setLoader(true));
    const a = document.createElement('a');
    if (filePath.startsWith('https://')) {
      a.href = await toDataURL(imgUrl);
    } else {
      a.href = imgUrl;
    }
    // a.href = `data:image/png;base64,${imgUrl}`;
    // a.href = await toDataURL(imgUrl);
    a.download = 'Image.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    dispatch(setLoader(false));
  }

  return (
    <div className="ProfileImageDialog">
      <Dialog
        maxWidth="md"
        open={show}
        transitionDuration={600}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleImageAction}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ProfileImageDialogButton">
          <DialogTitle>
            <IconButton
              aria-label="close"
              color="error"
              onClick={handleImageAction}
              sx={{
                position: 'absolute',
                right: isPdf ? 19 : 8,
                top: isPdf ? 14 : 8,
              }}
            >
              <CloseIcon />
            </IconButton>
            {!isPdf && (
            <IconButton
              color="success"
              // eslint-disable-next-line react/jsx-no-bind
              onClick={() => downloadImage()}
              sx={{
                position: 'absolute',
                right: 8,
                bottom: 8,
              }}
            >
              <CloudDownloadTwoToneIcon />
            </IconButton>
            )}
          </DialogTitle>
        </div>
        <DialogContent className="image_container_style">
          {isPdf ? (
            <iframe
              src={imgUrl}
              title="PDF Preview"
              width="600px"
              height="600px"
              style={{ border: 'none' }}
              onLoad={handleImageLoad}
            />
          ) : (
            <img
              src={imgUrl}
              alt="Preview"
              width="100%"
              height="100%"
              onLoad={handleImageLoad}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default DialogScannedImage;
